import React from "react";
import { Modal } from "react-bootstrap";
import "./RatePlanModal.css";
import RatePlan from "../../propertySetting/RatePlan";

const RatePlanModal = ({
    showModal,
    closeModal,
    propertyDetail,
}) => {
    // Ensure we have a propertyId
    const propertyId = propertyDetail?.propertyid;

    // Construct a propertyDetail object if it's missing but we have propertyid
    const effectivePropertyDetail = propertyDetail || { propertyid: propertyId };

    return (
        <Modal
            className="RatePlanModal"
            size="xl"
            centered
            // fullscreen="xxl-down"
            show={showModal}
            onHide={closeModal}
            dialogClassName="rate-plan-modal-dialog"
            fullscreen
            enforceFocus={false}
        >
            <Modal.Header closeButton>
                <Modal.Title>Rate Plan</Modal.Title>
            </Modal.Header>

            <Modal.Body className="rateplan-modal-body p-0">
                <div className="rate-plan-wrapper">
                    {!propertyId ? (
                        <div className="text-center py-5">
                            <p className="text-muted">No property selected</p>
                        </div>
                    ) : (
                        <RatePlan
                            propertyDetail={effectivePropertyDetail}
                            showOnlyUnmapped={true}
                            module="Revenue"
                        />
                    )}
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default RatePlanModal;
